import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, bonusesTotalValue } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-16" data-mp="pj6ds81asqsl">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-17" data-mp="avv3sakrleul">
        <header className="mx-auto max-w-narrow text-center" data-id="element-18" data-mp="fu6cuj38jlbr">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-19" data-mp="fsljgwsnq8fh">
            <GiftIcon className="h-8 w-8 text-gold-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-20" data-mp="5w8n1r5q9gh1" />
            6 Bonos incluidos
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg text-blue-900/75 md:text-xl" data-id="element-21" data-mp="3o3fz62ow37ly">
            Herramientas prácticas para que empieces hoy sin complicarte.
          </p>
        </header>

        <ul className="mt-12 grid gap-5 md:mt-16 md:grid-cols-3" data-id="element-22" data-mp="1mart7lkv262h">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="flex h-full flex-col rounded-2xl bg-white p-6 text-left shadow-soft ring-1 ring-blue-100" data-id="element-23" data-mp="1r78tfe5c4avx" data-mpi={index}>
              <span className="font-display text-4xl font-extrabold tracking-tight text-gold-300" data-id="element-24" data-mp="3dek4b6tqyjmc">
                0{index + 1}
              </span>
              <span className="mt-3 text-xs font-extrabold uppercase tracking-[0.14em] text-blue-700" data-id="element-25" data-mp="3n54xgeqnivxv">
                {bonus.tag}
              </span>
              <h3 className="mt-2 font-display text-xl font-extrabold leading-snug tracking-tight text-ink" data-id="element-26" data-mp="2zg3ydi3pkx59">
                {bonus.title}
              </h3>
              <p className="mt-2 text-blue-900/75" data-id="element-27" data-mp="38g0dot47kjnn">{bonus.description}</p>
              <p className="mt-auto flex items-center gap-3 pt-6" data-id="element-28" data-mp="38dw3xujmoqfg">
                <span className="text-sm text-blue-900/45 line-through" data-id="element-29" data-mp="33fm7lgm63js9">{bonus.value}</span>
                <span className="rounded-lg bg-gold-50 px-3 py-1 font-display text-sm font-extrabold uppercase text-gold-700 ring-1 ring-gold-200" data-id="element-30" data-mp="noq5gtsxfkyo">
                  Gratis
                </span>
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-blue-900 px-6 py-7 text-center text-white" data-id="element-31" data-mp="3hhr8fn7c3015">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-blue-100" data-id="element-32" data-mp="3lj32c4x8q7f5">
            Valor total de los bonos
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold tracking-tight md:text-3xl" data-id="element-33" data-mp="3qhwdhqp21mc5">
            <span className="text-blue-200 line-through" data-id="element-34" data-mp="2tu9naaikr075">{bonusesTotalValue}</span>
            <span className="ml-3 text-gold-300" data-id="element-35" data-mp="2xujsvm2gfolh">→ Gratis con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}